import React from "react";
import BlogFooterBottomSectionBoxes from "./BlogFooterBottomSectionBoxes";
type Config = {
  bgColor: string;
  bgColorHover: string;
  heading: string;
  href: string;
  src: string;
  linkTitle: string;
  text: string;
};
const config: {
  [key: string]: Config;
} = {
  Articles: {
    bgColor: "bg-gray-700",
    bgColorHover: "hover:bg-gray-900",
    heading: "Articles",
    href: "https://www.webstaurantstore.com/food-service-resources/articles.html",
    src: "/uploads/design/2024/3/Blog-Food-Service-Resources-Footer/article-icon.png",
    linkTitle: "Read Articles",
    text: "In-depth information and tips for running a successful restaurant"
  },
  "Buying Guides": {
    bgColor: "bg-green-500",
    bgColorHover: "hover:bg-green-700",
    heading: "Buying Guides",
    href: "https://www.webstaurantstore.com/food-service-resources/buying-guides.html",
    src: "/uploads/design/2024/3/Blog-Food-Service-Resources-Footer/buying-guide-icon.png",
    linkTitle: "Learn More",
    text: "Tools to help you find the perfect product for your business"
  }
};
const BlogFooterBottomSection = () => {
  return <div className="flex flex-col md:flex-row w-full xl:grid xl:grid-cols-2 xl:grid-rows-1 xl:gap-x-0 xl:gap-y-0 xl:grid-flow-col" data-sentry-component="BlogFooterBottomSection" data-sentry-source-file="index.tsx">
      {Object.entries(config).map(([key, {
      bgColor,
      bgColorHover,
      heading,
      href,
      linkTitle,
      src,
      text
    }]) => <BlogFooterBottomSectionBoxes key={key} bgColor={bgColor} bgColorHover={bgColorHover} heading={heading} href={href} linkTitle={linkTitle} src={src} text={text} />)}
    </div>;
};
export default BlogFooterBottomSection;